import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DragAndDropListComponent } from './drag-and-drop-list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { LoaderComponent } from './loader';
import { BreadcrumbComponent } from './breadcrumb';
import { DocumentInputComponent } from './document-input';

const components = [
  LoaderComponent,
  BreadcrumbComponent,
  DocumentInputComponent,
  DragAndDropListComponent,
];

@NgModule({
  declarations: [...components],
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    FontAwesomeModule,
    DragDropModule,
    MatProgressSpinnerModule,

    NgOptimizedImage,
  ],
  exports: [...components],
})
export class ComponentsModule {}
